import type { EndpointsRegistry, FetchClient } from '~/api/types'
import type { Route, RouteAssetAssociation, ZoneGeoPolyline } from '~/types/routes'
import type { RouteService } from '~/api/services/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'

const siteQueryParams = (siteId?: number): { site_id?: number } => (siteId ? { site_id: siteId } : {})

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): RouteService => {
  return {
    getAllRoutes: async (siteId?: number): Promise<Route[]> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.ROUTES_GET_ALL, {
        queryParams: siteQueryParams(siteId)
      })
      return await client<Route[]>(url, { method, headers, body })
    },
    getRoutesHierarchy: async (siteId?: number): Promise<RouteAssetAssociation[]> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.ROUTES_GET_HIERARCHY, {
        queryParams: siteQueryParams(siteId)
      })
      return await client<RouteAssetAssociation[]>(url, { method, headers, body })
    },
    getZoneGeoPolylines: async (zoneIds: number[]): Promise<ZoneGeoPolyline[]> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.ZONES_GET_GEO_POLYLINES, {
        queryParams: { ids: zoneIds.join(',') }
      })
      return await client<ZoneGeoPolyline[]>(url, { method, headers, body })
    }
  }
}
